'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginButton = function LoginButton(_ref) {
    var theme = _ref.theme,
        additionalClassName = _ref.additionalClassName,
        title = _ref.title,
        spidLogin = _ref.spidLogin;
    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)(theme.existing, additionalClassName),
            'data-test-tag': '@vg/salesposter:loginButton'
        },
        title,
        _react2.default.createElement(
            'span',
            { className: theme.spid },
            _react2.default.createElement(
                'button',
                { className: theme.logIn, onClick: spidLogin },
                'Logg inn'
            )
        )
    );
};

LoginButton.propTypes = {
    theme: _propTypes2.default.shape({}),
    additionalClassName: _propTypes2.default.string,
    title: _propTypes2.default.string.isRequired,
    spidLogin: _propTypes2.default.func.isRequired
};

LoginButton.defaultProps = {
    theme: {},
    additionalClassName: ''
};

exports.default = LoginButton;
//# sourceMappingURL=LoginButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/salesposter/lib/cjs/LoginButton.js
 ** module id = 737
 ** module chunks = 1
 **/